module.exports = __webpack_public_path__ + "img/push-header.7c176204.png";